import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./features/user/userSlice"
import fileReducer from "./features/file/fileSlice"
import productReducer from "./features/product/productSlice"
import cartReducer from "./features/cart/cartSlice"
import orderReducer from "./features/order/orderSlice"

export const store = configureStore({
    reducer: {
        auth: authReducer,
        file: fileReducer,
        product: productReducer,
        cart: cartReducer,
        order: orderReducer,
    }
})